import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL, umsUrl, adminAPIURL } from '../../../../Containers/Config/index.js';
import { SEARCH_CLIENT_PANEL, SEARCH_CLIENT_PANEL_SUCCESS, SEARCH_CLIENT_PANEL_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* searchClientPanel({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/client/customer-360/search`,
      method: 'POST',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        'Project-Code': 'ADMIN_ACCESS',
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      // cogoToast.success(response?.data?.message);
      yield put({
        type: SEARCH_CLIENT_PANEL_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: SEARCH_CLIENT_PANEL_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: SEARCH_CLIENT_PANEL_ERROR, payload: error });
  }
}

export function* watchSearchClientPanel() {
  yield takeEvery(SEARCH_CLIENT_PANEL, searchClientPanel);
}

function* searchClientPanelSaga() {
  yield all([fork(watchSearchClientPanel)]);
}

export default searchClientPanelSaga;
